<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="70%"
    top="5vh"
    custom-class="call-modal"
    @close="onClose"
  >
    <el-row slot="title" type="flex" justify="space-between" align="middle">
      <h2>ОБЗВОН, СЛЕДУЮЩИЙ КОНТАКТ</h2>
      <el-button type="text" class="close-btn" @click="toList">
        <b>КОНТАКТЫ ({{ total }})</b>
      </el-button>
    </el-row>
    <p v-if="!info.contact_id" class="empty ta-c">
      Контакты для обзвона отсутствуют
    </p>
    <template v-else>
      <el-row :gutter="60">
        <el-col :span="12">
          <p>Телефон:</p>
          <input
            v-mask="'+7 (###) ###-##-##'"
            :value="task.current.phone"
            readonly
            class="phone"
          />
        </el-col>
        <el-col :span="12">
          <p>ФИО:</p>
          <el-input :value="task.current.fio" readonly />
        </el-col>
      </el-row>
      <el-row>
        <p>Описание:</p>
        <el-input
          :rows="4"
          :value="task.current.description"
          type="textarea"
          readonly
        />
      </el-row>
      <contact-info-statuses :id="info.contact_id" />
      <el-row class="btn-block ta-r">
        <el-button type="primary" @click="calling = true"> Звонить </el-button>
      </el-row>
    </template>
    <calling-modal :visible="calling" :info="info" @close="calling = false" />
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CallingModal from '@/components/Modals/CallingModal'
import ContactInfoStatuses from '../ContactInfoStatuses'

export default {
  name: 'CallModal',
  components: { ContactInfoStatuses, CallingModal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      calling: false,
    }
  },
  computed: {
    ...mapGetters({ getTask: 'callCenter/getList' }),
    task() {
      return this.getTask('tasks', this.id)
    },
    info() {
      const { id: task_id, user_id, current } = this.task
      const contact_id = current ? current.id : 0

      return { task_id, user_id, contact_id }
    },
    total() {
      const { stats } = this.task

      return stats ? stats.total : 0
    },
  },
  methods: {
    toList() {
      this.onClose()
      this.$emit('set', 'contactsModal', this.id)
    },
    onClose() {
      this.$emit('set', 'callModal')
    },
  },
}
</script>

<style lang="sass">
.call-modal
  min-height: 700px
  h2
    margin: 30px
    font-weight: bold
    font-size: 18px
    line-height: 17px
  .close-btn
    margin-right: 30px
    text-decoration: underline
  .el-textarea__inner, .el-button
    font-size: 16px
    font-family: Rubik, sans-serif
  .el-dialog__header
    padding: 10px 20px 0px
  .el-dialog__body
    padding: 0 50px 40px
    p
      font-size: 18px
      line-height: 17px
      color: #000
      &.empty
        margin-top: 100px
    .el-input__inner, .el-textarea__inner
      font-weight: bold
      font-size: 17px
      color: #000
    .phone
      background-color: #FFF
      font-size: 17px
      font-weight: bold
      border-radius: 4px;
      border: 1px solid #DCDFE6
      width: 100%
      height: 40px;
      line-height: 40px
      padding: 0 15px
      outline: none
      box-sizing: border-box
      &:focus
        border-color: #409EFF
    .btn-block
      margin-top: 40px
      button
        width: 300px
        height: 47px
        font-weight: normal
</style>
